import type { Ctx } from "../types";
import { Action } from "gg-wf-scripts";
import { toast, type ToastVariant } from "../toast";

export const test_toast: Action<
  Ctx,
  { variant?: string; persist?: string; text?: string }
> = (_ctx, data, _params) => {
  const variant = (data.variant as ToastVariant) ?? "success";
  toast({
    variant,
    persist: data.persist === "true",
    text: data.text ?? `Test toast (${variant})`,
  });
  return { ok: true };
};
